import React, { useEffect, useRef, useState } from 'react';
import {
  TabContainer,
  TabTitle,
  AddButton,
  AddText,
  ContentContainer,
  Content,
  PaymentContainer,
  PaymentRow,
  PaymentDate,
  PaymentStatus,
  PaymentAmount,
  PaymentTotal,
  TotalContainer,
  PaymentTotalText,
  ButtonReject,
  ButtonAccept,
  Buttons,
  TitleSmall,
  IconPosition,
  RowModal,
  TotalText,
  TotalAmountContainer,
  Total,
  Scroll,
  StyledInput,
  StyledInputLast,
  SubtitlePayments,
  ContractName,
  TotalClientAmountContainer,
  PaymentDescRow,
  PaymentMethodType,
} from './ClientDetails.styles';
import { ReactComponent as Calendar } from '../../../assets/icons/date.svg';
import { ReactComponent as Add } from '../../../assets/icons/btnAdd.svg';
import ModalComponent from '../../../components/Modal/ModalComponent';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { useDispatch, useSelector } from 'react-redux';
import {
  acceptClientPayment,
  createClientPayment,
  createPaymentsClient,
  deleteClientPayment,
  editPaymentPlanForClient,
  getClientPayment,
  getClientPaymentPlan,
  rejectPaymentForClient,
} from '../../../store/slice/payment/asyncThunks';
import { selectClientData } from '../../../store/slice/vendor/slice';
import {
  selectAcceptClientRequestPaymentPending,
  selectClientPayments,
  selectCreateClientPaymentPending,
  selectCreatePaymentsClientPending,
  selectDeleteClientPaymentPending,
  selectEditPaymentPlanForClientPending,
  selectGetClientPaymentPending,
  selectRejectClientRequestPaymentPending,
} from '../../../store/slice/payment/slice';
import { dateFormatterHalfMonth } from '../../../utils/utils';
import { PAYMENT_STATUS } from '../../../utils/constants';
import { notifyError, notifyErrorLeft, notifyInfo } from '../../../utils/notify';
import { Waveform } from '@uiball/loaders';
import { NoDataContainer } from '../ClientsPage.styles';
import { ReactComponent as Delete } from '../../../assets/icons/delete.svg';

const exceptThisSymbols = ['e', 'E', '+', '-', '$'];

const Payments = ({ id, setIsVisible, deleteClientPaymentPending, clickedDeleteId, setClickedDeleteId }) => {
  const dispatch = useDispatch();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [numOfInstallments, setNumOfInstallments] = useState('');
  const [inputValues, setInputValues] = useState([]);
  const [totalAmount, setTotalAmount] = useState('');
  const [totalAmountWithoutDeposit, setTotalAmountWithoutDeposit] = useState('');
  const [depositAmount, setDepositAmount] = useState('');

  const client = useSelector(selectClientData);
  const createPaymentsClientPending = useSelector(selectCreatePaymentsClientPending);
  const clientPayments = useSelector(selectClientPayments);

  const getClientPaymentPending = useSelector(selectGetClientPaymentPending);
  const acceptClientRequestPaymentPending = useSelector(selectAcceptClientRequestPaymentPending);
  const rejectClientRequestPaymentPending = useSelector(selectRejectClientRequestPaymentPending);

  const [isClientModalOpen, setIsClientModalOpen] = useState(false);
  const [paidAmount, setAmountPaid] = useState('');
  const [paidDate, setPaidDate] = useState('');
  const [paymentMethodType, setPaymentMethodType] = useState('');

  const createClientPaymentPending = useSelector(selectCreateClientPaymentPending);

  const datePickerRef = useRef([]);
  const datePickerClientPaymentRef = useRef(null);

  const [isEditPaymentPlan, setIsEditPaymentPlan] = useState(false);
  const editPaymentPlanForClientPending = useSelector(selectEditPaymentPlanForClientPending);

  const handleCalendarIconClick = () => {
    if (datePickerClientPaymentRef.current) {
      datePickerClientPaymentRef.current.setOpen(true);
    }
  };

  useEffect(() => {
    dispatch(getClientPayment({ id: id }));
  }, [dispatch, id]);

  const handleInputChange = (index, value) => {
    const updatedValues = [...inputValues];
    updatedValues[index] = { ...updatedValues[index], amount: value };
    setInputValues(updatedValues);
    let total = sumTotal(updatedValues);
    setTotalAmount(parseFloat(total) + parseFloat(depositAmount));
    setTotalAmountWithoutDeposit(total);
  };

  const handleDateChange = (index, date) => {
    const updatedValues = [...inputValues];
    updatedValues[index] = { ...updatedValues[index], date };
    setInputValues(updatedValues);
  };

  const handleCountChange = event => {
    const inputValue = event.target.value;
    if (!isNaN(inputValue) && inputValue !== '') {
      let newCount = parseInt(inputValue, 10);
      if (newCount < 0) {
        setNumOfInstallments(0);
        setInputValues([]);
        newCount = 0;
        return;
      } else if (newCount > 12) {
        setNumOfInstallments(12);
        newCount = 12;
      } else {
        setNumOfInstallments(newCount);
        newCount = parseInt(inputValue, 10);
      }
      const oneAmount = Math.floor((totalAmountWithoutDeposit / newCount) * 100) / 100;
      const sumTotal = (newCount - 1) * oneAmount;
      const difference = (totalAmountWithoutDeposit - sumTotal).toFixed(2);
      setInputValues(
        Array(newCount)
          .fill()
          .map((_, index) => {
            if (index === newCount - 1) {
              return {
                date: new Date(),
                amount: difference,
              };
            } else {
              return {
                date: new Date(),
                amount: (Math.floor((totalAmountWithoutDeposit / newCount) * 100) / 100).toFixed(2),
              };
            }
          }),
      );
    } else {
      console.log('Entered value is not a number.');
      setNumOfInstallments(0);
      setInputValues([]);
    }
  };

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setNumOfInstallments('');
    setInputValues([]);
    setTotalAmount('');
    setDepositAmount('');
  };

  const openClientPaymentModal = () => {
    setIsClientModalOpen(true);
  };

  const closeClientPaymentModal = () => {
    setIsClientModalOpen(false);
    setAmountPaid('');
    setPaidDate('');
    setPaymentMethodType('');
  };

  const openEditClientPaymentModal = () => {
    dispatch(getClientPaymentPlan({ id: client.id }))
      .unwrap()
      .then(data => {
        setNumOfInstallments(data.data.length);
        const formttedData = [];
        for (const installment of data.data) {
          const formatted = { amount: installment.amount, date: new Date(installment.date) };
          formttedData.push(formatted);
        }
        setInputValues(formttedData);
        setTotalAmount(data.totalAmount);
        setDepositAmount(data.deposit);
        setTotalAmountWithoutDeposit(data.totalAmount - data.deposit);
        setIsModalOpen(true);
        setIsEditPaymentPlan(true);
      })
      .catch(err => {
        notifyError(err.message);
      });
  };

  const closeEditClientPaymentModal = () => {
    setIsClientModalOpen(false);
    setIsEditPaymentPlan(false);
    setAmountPaid('');
    setPaidDate('');
  };

  const handleCreatePaymentsForClient = () => {
    const data = {
      id: client.id,
      body: {
        installments: inputValues,
        deposit: depositAmount,
        totalAmount: totalAmount,
      },
    };
    dispatch(createPaymentsClient(data))
      .unwrap()
      .then(() => {
        closeModal();
      })
      .catch(err => {
        console.log(err);
        notifyErrorLeft(err.message);
      });
  };

  const handleEditPaymentsForClient = () => {
    const data = {
      id: client.id,
      body: {
        installments: inputValues,
        deposit: depositAmount,
        totalAmount: totalAmount,
      },
    };
    dispatch(editPaymentPlanForClient(data))
      .unwrap()
      .then(() => {
        closeModal();
      })
      .catch(err => {
        console.log(err);
        notifyErrorLeft(err.message);
      });
  };

  const handleCreateOnePaymentForClient = () => {
    const data = {
      id: client.id,
      body: {
        amount: paidAmount,
        date: paidDate.getTime(),
        paymentMethodType,
      },
    };
    dispatch(createClientPayment(data))
      .unwrap()
      .then(() => {
        closeClientPaymentModal();
        dispatch(getClientPayment({ id: id }))
          .unwrap()
          .then(() => {})
          .catch(err => {
            console.log(err);
            //notifyErrorLeft(err.message);
          });
      })
      .catch(err => {
        console.log(err);
        notifyErrorLeft(err.message);
      });
  };

  const handleStatusText = status => {
    let text = '';
    if (status === PAYMENT_STATUS.PENDING) {
      text = 'Pending';
    } else if (status === PAYMENT_STATUS.APPROVED) {
      text = 'Approved';
    } else if (status === PAYMENT_STATUS.REJECTED) {
      text = 'Rejected';
    }
    return text;
  };

  const handleAcceptPayment = paymentId => {
    dispatch(acceptClientPayment({ paymentId }))
      .unwrap()
      .then(() => {
        notifyInfo('Payment accepted successfully');
        dispatch(getClientPayment({ id: id }))
          .unwrap()
          .then(() => {})
          .catch(err => {
            console.log(err);
            //notifyErrorLeft(err.message);
          });
      })
      .catch(err => {
        console.log(err);
        notifyError(err.message);
      });
  };

  const handleRejectPayment = paymentId => {
    dispatch(rejectPaymentForClient({ paymentId }))
      .unwrap()
      .then(() => {
        notifyInfo('Payment rejected successfully');
      })
      .catch(err => {
        console.log(err);
        notifyError(err.message);
      });
  };

  const sumTotal = updatedArray => {
    let total = 0;
    for (const instalment of updatedArray) {
      total = total + parseFloat(instalment.amount);
    }

    return total.toFixed(2);
  };

  const handleIsInstallmentsEqualToTotal = () => {
    let total = sumTotal(inputValues);

    if (parseFloat(total) === parseFloat(totalAmountWithoutDeposit)) {
      return true;
    }
    return false;
  };

  const handleChangeTotalAmount = value => {
    setTotalAmount(value);
    if (+value < +depositAmount) {
      setDepositAmount(0);
    }
    setTotalAmountWithoutDeposit(+value - +depositAmount);
    setNumOfInstallments(0);
    setInputValues([]);
  };

  return (
    <ContentContainer>
      <TabContainer>
        <TabTitle>Payments</TabTitle>
        {!getClientPaymentPending && (
          <>
            <AddButton
              onClick={() => {
                !clientPayments.totalAmountVendor && clientPayments.notPaidInstallments.length === 0
                  ? openModal()
                  : openClientPaymentModal();
              }}>
              <Add />
              <AddText>
                {!clientPayments.totalAmountVendor && clientPayments.notPaidInstallments.length === 0
                  ? 'Set Up Payments'
                  : 'Add Payment'}
              </AddText>
            </AddButton>
            {clientPayments.totalAmountVendor && (
              <AddButton
                onClick={() => {
                  openEditClientPaymentModal();
                }}>
                <Add />
                <AddText>{'Edit Payment Plan'}</AddText>
              </AddButton>
            )}
          </>
        )}
      </TabContainer>
      {!getClientPaymentPending ? (
        <Content className="vertical-scroll">
          <TotalContainer>
            <TotalClientAmountContainer>
              <PaymentTotalText>Total: </PaymentTotalText>
              <PaymentTotal>
                {clientPayments.totalAmountVendor
                  ? ` $${parseFloat(clientPayments.totalAmountVendor)
                      .toFixed(2)
                      .replace(/\d(?=(\d{3})+\.)/g, '$&,')}`
                  : '$0'}
              </PaymentTotal>
            </TotalClientAmountContainer>
            <TotalClientAmountContainer>
              <PaymentTotalText>Total Paid: </PaymentTotalText>
              <PaymentTotal>
                {clientPayments.totalPaidAmount
                  ? ` $${parseFloat(clientPayments.totalPaidAmount)
                      .toFixed(2)
                      .replace(/\d(?=(\d{3})+\.)/g, '$&,')}`
                  : '$0'}
              </PaymentTotal>
            </TotalClientAmountContainer>
            <TotalClientAmountContainer>
              <PaymentTotalText>Balance Due: </PaymentTotalText>
              <PaymentTotal>
                {clientPayments.remainingAmount
                  ? `$${parseFloat(clientPayments.remainingAmount)
                      .toFixed(2)
                      .replace(/\d(?=(\d{3})+\.)/g, '$&,')}`
                  : '$0'}
              </PaymentTotal>
            </TotalClientAmountContainer>
          </TotalContainer>

          {clientPayments.data.length > 0 ? (
            <>
              {clientPayments.data.map(item => (
                <PaymentContainer key={item.id} className={item.status === 'Pending' ? 'pending' : ''}>
                  <PaymentRow>
                    <PaymentDate>{dateFormatterHalfMonth(item.date)}</PaymentDate>
                    <PaymentStatus>{handleStatusText(item.status)}</PaymentStatus>
                  </PaymentRow>
                  <PaymentRow>
                    <PaymentDescRow>
                      {item.amount && (
                        <PaymentAmount>
                          $
                          {parseFloat(item.amount)
                            .toFixed(2)
                            .replace(/\d(?=(\d{3})+\.)/g, '$&,')}
                        </PaymentAmount>
                      )}
                      {item.paymentMethodType && <PaymentMethodType>{item.paymentMethodType}</PaymentMethodType>}
                    </PaymentDescRow>

                    {item.status === PAYMENT_STATUS.PENDING ? (
                      <Buttons>
                        {rejectClientRequestPaymentPending || acceptClientRequestPaymentPending ? (
                          <Waveform size={26} lineWeight={3.5} speed={1} color="black" />
                        ) : (
                          <>
                            <ButtonReject
                              disabled={rejectClientRequestPaymentPending}
                              onClick={() => {
                                handleRejectPayment(item.id);
                              }}>
                              {'Reject'}
                            </ButtonReject>
                            <ButtonAccept
                              disabled={acceptClientRequestPaymentPending}
                              onClick={() => {
                                handleAcceptPayment(item.id);
                              }}>
                              {'Accept'}
                            </ButtonAccept>
                          </>
                        )}
                      </Buttons>
                    ) : null}
                    {item.status === PAYMENT_STATUS.APPROVED &&
                      !item.isDeposit &&
                      (deleteClientPaymentPending && clickedDeleteId === item.id ? (
                        <Waveform size={26} lineWeight={3.5} speed={1} color="black" />
                      ) : (
                        <Delete
                          className="icon-delete"
                          onClick={() => {
                            setIsVisible(true);
                            setClickedDeleteId(item.id);
                          }}
                        />
                      ))}
                  </PaymentRow>
                </PaymentContainer>
              ))}
            </>
          ) : (
            <>
              {clientPayments.notPaidInstallments.length === 0 && (
                <NoDataContainer>
                  <ContractName>You don't have payments with {client.firstName}.</ContractName>
                </NoDataContainer>
              )}
            </>
          )}
          {clientPayments.notPaidInstallments.length > 0 ? (
            <>
              <SubtitlePayments>Future payments</SubtitlePayments>
              {clientPayments.notPaidInstallments.map(item => {
                return (
                  <PaymentContainer key={item.id} className={item.status === 'Pending' ? 'pending' : ''}>
                    <PaymentRow>
                      <PaymentDate>{dateFormatterHalfMonth(item.date)}</PaymentDate>
                      <PaymentStatus>{handleStatusText(item.status)}</PaymentStatus>
                    </PaymentRow>
                    <PaymentRow>
                      {item.amount && (
                        <PaymentAmount>
                          {item.remainingAmount
                            ? `$${parseFloat(item.remainingAmount)
                                .toFixed(2)
                                .replace(/\d(?=(\d{3})+\.)/g, '$&,')}`
                            : '$0'}
                        </PaymentAmount>
                      )}
                    </PaymentRow>
                  </PaymentContainer>
                );
              })}
            </>
          ) : (
            <>
              {clientPayments.data.length > 0 && (
                <NoDataContainer>
                  <ContractName>All payments are paid.</ContractName>
                </NoDataContainer>
              )}
            </>
          )}
        </Content>
      ) : (
        <NoDataContainer>
          <Waveform size={40} lineWeight={3.5} speed={1} color="black" />
        </NoDataContainer>
      )}
      <ModalComponent
        isOpen={isModalOpen}
        onClose={closeModal}
        title={!isEditPaymentPlan ? 'Set Up Payments' : 'Edit Client Payment Plan'}
        width={'800px'}
        rightButtonTitle={isEditPaymentPlan && 'Save'}
        onCreate={() => {
          !isEditPaymentPlan ? handleCreatePaymentsForClient() : handleEditPaymentsForClient();
        }}
        createDisabled={
          !numOfInstallments ||
          numOfInstallments <= 0 ||
          !inputValues.length ||
          !totalAmount ||
          !handleIsInstallmentsEqualToTotal()
        }
        cancelDisabled={createPaymentsClientPending || editPaymentPlanForClientPending}
        loading={createPaymentsClientPending || editPaymentPlanForClientPending}>
        <StyledInput
          placeholder="Total Cost"
          value={totalAmount}
          type={'number'}
          onKeyDown={e => exceptThisSymbols.includes(e.key) && e.preventDefault()}
          onChange={e => handleChangeTotalAmount(e.target.value)}
        />
        <StyledInput
          placeholder="Deposit"
          value={depositAmount}
          type={'number'}
          onKeyDown={e => exceptThisSymbols.includes(e.key) && e.preventDefault()}
          onChange={e => {
            setDepositAmount(e.target.value);
            setTotalAmountWithoutDeposit(totalAmount - e.target.value);
            setNumOfInstallments(0);
            setInputValues([]);
          }}
        />
        <TitleSmall>Payments</TitleSmall>
        <StyledInputLast
          placeholder="Enter Payment Number"
          type={'number'}
          value={numOfInstallments}
          onChange={handleCountChange}
          disabled={isNaN(totalAmount) || !totalAmount}
        />
        {numOfInstallments === '' ? null : (
          <Scroll>
            {inputValues.map((value, index) => (
              <RowModal key={index}>
                <div className="border-bottom-300">
                  <DatePicker
                    placeholderText="Select Date"
                    className="date-picker"
                    selected={value.date}
                    calendarClassName="scale2"
                    dateFormat="MMMM d, yyyy"
                    onChange={date => handleDateChange(index, date)}
                    index={index}
                    ref={ref => (datePickerRef.current[index] = ref)}
                  />
                  <IconPosition
                    onClick={() => {
                      datePickerRef.current[index].setOpen(true);
                    }}>
                    <Calendar />
                  </IconPosition>
                </div>
                <StyledInput
                  leftIcon={<div style={{ marginTop: 11 }}>$</div>}
                  key={index}
                  value={`${value.amount}`}
                  type={'number'}
                  placeholder={`Amount`}
                  onKeyDown={e => exceptThisSymbols.includes(e.key) && e.preventDefault()}
                  onChange={e => handleInputChange(index, e.target.value)}
                />
              </RowModal>
            ))}
          </Scroll>
        )}

        {totalAmount && (
          <TotalAmountContainer>
            <Total>Total</Total>
            <TotalText>
              $
              {parseFloat(+totalAmount)
                .toFixed(2)
                .replace(/\d(?=(\d{3})+\.)/g, '$&,')}
            </TotalText>
          </TotalAmountContainer>
        )}
      </ModalComponent>

      <ModalComponent
        isOpen={isClientModalOpen}
        onClose={closeClientPaymentModal}
        title={'Create Payment For Client'}
        width={'800px'}
        onCreate={handleCreateOnePaymentForClient}
        createDisabled={!paidDate || !paidAmount || !paymentMethodType}
        cancelDisabled={createClientPaymentPending}
        loading={createClientPaymentPending}>
        <StyledInput placeholder="Client" value={client.firstName + ' ' + client.lastName} disabled />
        <StyledInput
          placeholder="Amount"
          value={paidAmount}
          type={'number'}
          onKeyDown={e => exceptThisSymbols.includes(e.key) && e.preventDefault()}
          onChange={e => setAmountPaid(e.target.value)}
        />
        <StyledInput
          placeholder="Payment Method"
          value={paymentMethodType}
          onChange={e => setPaymentMethodType(e.target.value)}
        />
        <div className="border-bottom-300">
          <DatePicker
            placeholderText="Select Date"
            className="date-picker"
            selected={paidDate}
            calendarClassName="scale2"
            dateFormat="MMMM d, yyyy"
            onChange={date => setPaidDate(date)}
            ref={datePickerClientPaymentRef}
          />
          <IconPosition onClick={handleCalendarIconClick}>
            <Calendar />
          </IconPosition>
        </div>
      </ModalComponent>
    </ContentContainer>
  );
};

export default Payments;
